import React, { useEffect, useState } from 'react';
import { getAdminGames } from '../../services/ledgerService';
import { BackButton } from '../../components/BackButton';
import TimeWindowFilter, { useTimeWindow } from './TimeWindowFilter';
import './GameDetails.css';

const GameDetails = () => {
    const { from, to } = useTimeWindow();
    const [games, setGames] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setGames(null);
        setError(null);
        getAdminGames({ from, to })
            .then((body) => {
                if (cancelled) return;
                setGames(body.games || []);
            })
            .catch((err) => {
                if (cancelled) return;
                console.error('Failed to load created games', err);
                setError(err.message || 'Failed to load games');
            });
        return () => { cancelled = true; };
    }, [from, to]);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="game-details">
            <div className="detail-header">
                <BackButton to="/admin" />
                <h1>Games Created</h1>
            </div>
            <TimeWindowFilter />
            {error ? (
                <p className="text-danger">Error: {error}</p>
            ) : games === null ? (
                <p className="empty-state">Loading...</p>
            ) : games.length === 0 ? (
                <p className="empty-state">No games created in this window.</p>
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>House Name</th>
                            <th>Owner Name</th>
                            <th>Owner Email</th>
                            <th>Event Date</th>
                            <th>Event Name</th>
                            <th>Number of Players</th>
                            <th>Total Buy Ins</th>
                        </tr>
                    </thead>
                    <tbody>
                        {games.map((game) => (
                            <tr key={game.gameId}>
                                <td>{game.houseDescription}</td>
                                <td>{game.ownerName}</td>
                                <td>{game.ownerEmail}</td>
                                <td>{formatDate(game.eventDate)}</td>
                                <td>{game.gameDescription}</td>
                                <td>{game.numPlayers}</td>
                                <td>{game.totalBuyIns}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default GameDetails;
